import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Mint from "mint-ui";
import 'mint-ui/lib/style.css'
import { Field } from 'vant';
Vue.config.productionTip = false
Vue.use(Mint)
Vue.use(Field)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
